/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSummariesControllerFindOneQueryResponse, ApplicationSummariesControllerFindOnePathParams, ApplicationSummariesControllerFindOneQueryParams, ApplicationSummariesControllerFindOne400, ApplicationSummariesControllerFindOne401, ApplicationSummariesControllerFindOne403, ApplicationSummariesControllerFindOne404 } from "../../models/checklistsController/ApplicationSummariesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationSummariesControllerFindOne } from "../../clients/checklistsService/applicationSummariesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationSummariesControllerFindOneQueryKey = (id: ApplicationSummariesControllerFindOnePathParams["id"], params: ApplicationSummariesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-application-summaries/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ApplicationSummariesControllerFindOneQueryKey = ReturnType<typeof applicationSummariesControllerFindOneQueryKey>;
export function applicationSummariesControllerFindOneQueryOptions(id: ApplicationSummariesControllerFindOnePathParams["id"], params?: ApplicationSummariesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationSummariesControllerFindOneQueryKey(id, params);
  return queryOptions<ApplicationSummariesControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationSummariesControllerFindOne400 | ApplicationSummariesControllerFindOne401 | ApplicationSummariesControllerFindOne403 | ApplicationSummariesControllerFindOne404>, ApplicationSummariesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationSummariesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist application summary by ID
 * {@link /api/v1/checklist-application-summaries/:id}
 */
export function useApplicationSummariesControllerFindOne<TData = ApplicationSummariesControllerFindOneQueryResponse, TQueryData = ApplicationSummariesControllerFindOneQueryResponse, TQueryKey extends QueryKey = ApplicationSummariesControllerFindOneQueryKey>(id: ApplicationSummariesControllerFindOnePathParams["id"], params?: ApplicationSummariesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ApplicationSummariesControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationSummariesControllerFindOne400 | ApplicationSummariesControllerFindOne401 | ApplicationSummariesControllerFindOne403 | ApplicationSummariesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationSummariesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...applicationSummariesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationSummariesControllerFindOne400 | ApplicationSummariesControllerFindOne401 | ApplicationSummariesControllerFindOne403 | ApplicationSummariesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}